import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-4 py-4.5 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500 mb-4"
}

import { computed, onUnmounted, ref, watch } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsChip from "@/components/GgmsChip.vue"
import { SearchIcon } from "@heroicons/vue/outline"
import { useTagStore } from "@/stores/tag"
import { Tag } from "@/shared/models/tag"
import { debounce, getNotFoundText } from "@/shared/utils/helpers"

interface Props {
    tagsSelectedState: boolean[]
    hasFilterTags: boolean
    typeName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterTag',
  props: {
    tagsSelectedState: {},
    hasFilterTags: { type: Boolean },
    typeName: {}
  },
  emits: ["onTagSelect"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const tagStore = useTagStore()

const localtagsSelectedState = ref<boolean[]>(props.tagsSelectedState)

const tags = computed(() => tagStore.tableState.data)

function getTagClass(tag: Tag) {
    return !tag.isHidden ? "mb-5 last:mb-0" : ""
}

function createFilterTag() {
    // get the selected tags ids which are selected in localtagsSelectedState
    const selectedTagsIds = localtagsSelectedState.value
        .map((selected, index) => (selected ? tags.value[index]._id : null))
        .filter((id) => id !== null)

    emit("onTagSelect", selectedTagsIds)
}

onUnmounted(() => {
    tagStore.tableState.search = ""
})

watch(
    () => tagStore.tableState.search,
    debounce(() => {
        if (props.hasFilterTags) {
            // this is to prevent the search from being triggered when the modal is closed
            return
        }
        tagStore.tableState.currentPage = 0
        const localTypeName = props.typeName === "template" ? "messaging-template" : props.typeName
        tagStore.tableState.typeName = localTypeName
        tagStore.getTags()
    }, 250)
)

watch(
    () => localtagsSelectedState.value,
    () => {
        createFilterTag()
    },
    { deep: true }
)

watch(
    () => props.tagsSelectedState,
    () => {
        localtagsSelectedState.value = props.tagsSelectedState
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GgmsInput, {
      modelValue: _unref(tagStore).tableState.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(tagStore).tableState.search) = $event)),
      placeholder: "Search values",
      iconStart: _unref(SearchIcon)
    }, null, 8, ["modelValue", "iconStart"]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(tagStore).tableState.isLoading)
        ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tag._id,
                class: _normalizeClass(["flex items-center", getTagClass(tag)])
              }, [
                (!tag.isHidden)
                  ? (_openBlock(), _createBlock(GgmsCheckBox, {
                      key: 0,
                      modelValue: localtagsSelectedState.value[i],
                      "onUpdate:modelValue": ($event: any) => ((localtagsSelectedState.value[i]) = $event),
                      indeterminate: _ctx.tagsSelectedState[i] === null
                    }, {
                      default: _withCtx(() => [
                        _createVNode(GgmsChip, {
                          bgColor: tag.backgroundColor,
                          textColor: tag.foregroundColor,
                          isRemovable: false,
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["bgColor", "textColor"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "indeterminate"]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128)),
            (!tags.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(getNotFoundText)("tags", _unref(tagStore).tableState.search)), 1))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ], 64))
}
}

})